import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { Tile } from '@op/opds.opux';
import { space, color } from '@op/opds.tokens';
import { Message } from '@messageformat/react';
import { IconInformation } from '@op/opds.opux-icons/indicator';
import inflationGraphDataSeries from '../../inflationGraphDataSeries.json';
import { getChartOptionsWithOverrides } from '../../util/defaultOptions';

const InflationGraph = (): JSX.Element => {
  const options = getChartOptionsWithOverrides({
    accessibility: {
      enabled: false,
    },
    title: {
      text: undefined,
    },
    chart: {
      marginBottom: 24,
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: { enabled: false },
    plotOptions: {
      series: {
        turboThreshold: 1000,
        dataGrouping: {
          enabled: true,
          approximation: 'open',
          groupPixelWidth: 10,
        },
        color: color.indicator.default,
        enableMouseTracking: false,
        pointStart: Date.UTC(1960, 1, 1),
        pointInterval: (365 * 24 * 3600 * 1000) / 12,
        marker: {
          enabled: false,
        },
      },
    },
    yAxis: {
      showLastLabel: true,
      showFirstLabel: true,
      ceiling: 100,
      opposite: true,
    },
    xAxis: {
      opposite: true,
      type: 'datetime',
      lineWidth: 0,
      minorGridLineWidth: 0,
      tickInterval: 365 * 24 * 3600 * 1000 * 12,
      units: [['year', [1]]],
      minorTickLength: 0,
      tickLength: 0,
    },
    series: inflationGraphDataSeries as Highcharts.SeriesOptionsType[],
  });

  return (
    <>
      <Tile style={{ marginTop: space.default }}>
        <figure>
          <figcaption>
            <p className="investoracademy-general-graph-title">
              <Message id="course1.inflation_graph_title" />
            </p>
            <p className="investoracademy-general-graph-description">
              <Message id="course1.inflation_graph_description" />
            </p>
          </figcaption>
          <div style={{ display: 'none' }} id="inflation_graph">
            <Message id="course1.inflation_graph_text" />
          </div>
          <div role="img" aria-labelledby="inflation_graph">
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
        </figure>
      </Tile>
      <p
        className="opds-styles-v1-text-label-small"
        style={{ display: 'flex', paddingBottom: space.default }}
      >
        <IconInformation />
        <Message id="course1.inflation_graph_sources" />
      </p>
    </>
  );
};

export default InflationGraph;
